// @francesca - img are fine, link to drive folder here: t.ly/gCLF

export default {
  giftcard: {
    header: {
      title: 'Gutschein verschenken für Erlebnisse',
      buttonLabel: 'In den Warenkorb',
      titleColor: '#FFFFFF',
      bgColor: '#61B0BC',
    },

    validity: 'Gutschein bequem ausdrucken',
    forAnyKonfetti: 'Einlösbar für über {eventCount} konfetti Erlebnisse',
    experience: 'Ab Kauf 3 Jahre gültig',

    /// COMMENT HERE - I don't understand where these are/stand for

    mostBought: '',
    pickFavorite: '',

    option_1: '30',
    option_2: '50',
    option_3: '100',
    option_4: '200',
    options: 'Gutschein kaufen',
    value: 'Wert wählen',
    select: 'Beliebte Werte',
    input: 'Wähle Deinen eigenen Wert',
    inputError:
      'Bitte wähle einen Betrag zwischen 15-200€ für Deinen Gutschein',

    bookAction: 'In den Warenkorb',

    mainContent: {
      one: {
        title: 'Vorfreude und gemeinsame Zeit verschenken',
        description:
          'Der wohl kreativste Geschenkgutschein: Verschenke mit konfetti besondere Vorfreude und eine schöne Zeit. Von Action-Painting über italienisch Kochen, bis hin zu Töpfern an der Drehscheibe oder Verkosten exquisiter Cocktails - bei konfetti findet jeder das passende Event.',
      },
      two: {
        title: 'Erlebnisgutschein, mit dem Du von echten Experten lernst',
        description:
          'Jedes Erlebnis wird von erfahrenen Experten geleitet. Mit dem konfetti Gutschein triffst Du auf Sommeliers, Köche, Handwerker, Künstler und viele weitere Menschen, die Freude daran haben, ihre Leidenschaft zu teilen.',
      },
      three: {
        title: 'Das kreativste Last Minute Geschenk: Der Gutschein für Kurse',
        description:
          'Ein Last-Minute-Geschenk, bei dem man merkt, dass Du Dir wirklich Gedanken gemacht hast. Wähle den Gutschein, der am besten zum Beschenkten passt. Den Gutschein erhältst Du direkt zum Ausdrucken per E-Mail oder als Geschenkkarte per Post.',
      },
    },

    content: {
      title: 'Besondere Erlebnisse verschenken',
      icons: {
        one: {
          title: 'Lege den Gutscheinwert fest',
          description: 'Von 15 bis 500 Euro - Du bestimmst den Gutscheinwert.',
        },
        two: {
          title: 'Persönliches Last Minute Geschenk',
          description:
            'Nach Deinem Kauf senden wir Dir den Gutschein zum Drucken via E-Mail zu.',
        },
        three: {
          title: 'Optionale Gutschein-Geschenkkarte',
          description:
            'Entscheidest Du Dich für die Geschenkkarte, schicken wir diese am nächsten Werktag an Deine Adresse.',
        },
        four: {
          title: 'Gutschein verschenken für Kurse',
          description:
            'Einlösbar für mehr als {eventCount} einzigartige Erlebnisse - in ganz Deutschland, Österreich und online.',
        },
      },
    },

    breadcrumb: {
      value: 'Gutschein',
    },

    bookingSolution: {
      gridTitle: 'Unser Geschenkgutschein',
      gridSubtitle: 'Einzigartige Geschenkidee für ein tolles Erlebnis',
      grid1: {
        title: 'Zeit verschenken kommt von Herzen',
        content:
          'Verschenke ein besonderes Erlebnis, das in Erinnerung bleibt.',
      },
      grid2: {
        title: 'Das kreativste Last-Minute-Geschenk',
        content:
          'Den Gutschein erhältst Du per E-Mail. Du kannst ihn direkt zu Hause ausdrucken.',
      },
      grid3: {
        title: 'Für jedes Budget das passende Geschenk',
        content: 'Von 15 bis 200 Euro - Du bestimmst den Gutscheinwert.',
      },
      cardTags: 'Verschenke Zeit; Erlebnisse',
    },

    magazineTitle: 'Ein Erlebnis schenken',

    seo: {
      name: 'konfetti Gutschein',
      description: 'Gutschein verschenken für über {eventCount} Erlebnisse',
    },
  },
}
